import { ArrowRightWrapped } from '@/assets/icons'
import styled from '@emotion/styled'
import { Link, isMatch, useMatches } from '@tanstack/react-router'
import { Box, Flex } from './Flex'
import { Headline } from './Typography'

const Wrapper = styled(Flex)`
  width: 100%;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`

const BreadcrumbLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.7;
  }
`

const Separator = styled.span`
  opacity: 0.5;
  user-select: none;
`

export const Breadcrumbs = () => {
  const matches = useMatches()

  if (matches.some((match) => match.status === 'pending')) return null

  const matchesWithCrumbs = matches.filter((match) =>
    isMatch(match, 'loaderData.crumb'),
  )

  if (matchesWithCrumbs.length === 0) return null

  if (matchesWithCrumbs.length === 1) {
    const match = matchesWithCrumbs[0]
    return <Headline as="h2">{match.loaderData?.crumb}</Headline>
  }

  const [parentMatch, currentMatch] = matchesWithCrumbs.slice(-2)

  return (
    <Wrapper>
      <BreadcrumbLink
        from={currentMatch?.fullPath}
        to={parentMatch?.fullPath}
        aria-label={`Navigate back to ${parentMatch?.loaderData?.crumb}`}
      >
        <Box
          style={{
            transform: 'rotate(180deg)',
            alignContent: 'start',
            cursor: 'pointer',
          }}
        >
          <ArrowRightWrapped />
        </Box>
      </BreadcrumbLink>
      <Headline as="span">
        <BreadcrumbLink
          from={currentMatch?.fullPath}
          to={parentMatch?.fullPath}
        >
          {parentMatch?.loaderData?.crumb}
        </BreadcrumbLink>
        <Separator> › </Separator>
        <span>{currentMatch?.loaderData?.crumb}</span>
      </Headline>
    </Wrapper>
  )
}
